import React from 'react';
import PropTypes from 'prop-types';
import AppointmentsList from '../../editDetailsCustomer/containers/AppointmentsList';
import AddAppointmentsButton from '../../../../common/buttons/addAppointmentsButton';

const Appointments = ({ appointmentData, activeType }) => (
  <div>
    <div className="u-text-right u-mt u-mr">
      <AddAppointmentsButton
        content="New appointment"
        data={appointmentData}
        display-if={activeType !== 'brand'}
      />
    </div>
    <div>
      <AppointmentsList />
    </div>
  </div>
);

Appointments.propTypes = {
  activeType: PropTypes.string.isRequired,
  appointmentData: PropTypes.object.isRequired,
};

export default Appointments;
